export function initNav(): void {
    const header = document.querySelector<HTMLElement>('[data-swl-header]');

    if (header === null) {
        return;
    }

    const toggle = header.querySelector<HTMLButtonElement>('[data-swl-nav-toggle]');
    const panel = header.querySelector<HTMLElement>('[data-swl-nav-panel]');

    const setOpen = (open: boolean): void => {
        header.classList.toggle('is-menu-open', open);
        toggle?.setAttribute('aria-expanded', String(open));
        panel?.toggleAttribute('inert', !open);
    };

    setOpen(false);

    toggle?.addEventListener('click', () => {
        setOpen(!header.classList.contains('is-menu-open'));
    });

    header.addEventListener('keydown', event => {
        if (event.key === 'Escape' && header.classList.contains('is-menu-open')) {
            setOpen(false);
            toggle?.focus();
        }
    });

    let resizeTimer: number | undefined;

    window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(() => {
            if (window.innerWidth >= 1024) {
                setOpen(false);
            }
        }, 200);
    });

    let scrolled = false;
    let ticking = false;

    // Coalesce scroll events into one rAF and only touch the DOM when the state flips.
    const applyScrolled = (): void => {
        const next = window.scrollY >= 15;

        if (next !== scrolled) {
            scrolled = next;
            header.classList.toggle('is-scrolled', next);
        }

        ticking = false;
    };

    const onScroll = (): void => {
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(applyScrolled);
        }
    };

    applyScrolled();
    window.addEventListener('scroll', onScroll, { passive: true });
}
